import React from 'react';

import { FormattedMessage } from 'react-intl';
import { List, Link } from '@printdeal/ui-library';

export interface UploadSpecification {
  file: {
    contentType: string;
    fileName: string;
    url: string;
  };
  id: string;
  title: string;
}

interface Props {
  uploadSpecifications?: UploadSpecification[];
}

export const ProductUploadSpecifications = ({
  uploadSpecifications,
}: Props) => (
  <div className="pd-flex pd-flex-col pd-gap-4 pd-p-4">
    <p>
      <FormattedMessage
        id="product.detailPage.tabUploadSpecifications.tabIntroText"
        defaultMessage="Below you will find the file specifications for the file(s) you need to deliver."
      />
    </p>

    <List variant="icon" className="pd-grid pd-grid-cols-1 md:pd-grid-cols-2">
      {uploadSpecifications?.map((specification) =>
        specification?.file?.url && specification?.title && (
          <List.Item key={specification.id}>
            <Link href={specification.file.url} variant="secondary" target="_blank">
              {specification.title}
            </Link>
          </List.Item>
        ))}
    </List>
  </div>
);
